import React, { useState, useRef } from "react";
import { useViewport } from "js/hooks/useViewport";
import { useOutsideClick } from "js/hooks/useOutsideClick";
import PropTypes from "prop-types";

import HeaderSearch from "./HeaderSearch";
import {
    Dropdown,
    ToggleButton,
    DropdownContents,
    DropdownOption,
    ButtonText
} from "./dropdownStyles";
import AngleDownSvg from "./images/AngleDownSvg";

import { searchTypeButtons } from "./data";

import { placeholderText, searchTypeForPath } from "./helpers";

const DefaultSearch = ({ placeholder }) => {
    const initialSearchType = searchTypeForPath();
    const [searchType, setSearchType] = useState(initialSearchType);

    const [menuHidden, setMenuHidden] = useState(true);
    const mobileMenuRef = useRef();
    const outsideClick = useOutsideClick(mobileMenuRef);

    // show the icon for Icons; if photos, show the icon for Photos:
    const dropdownButtonValue =
        searchType === "Icons"
            ? searchTypeButtons[0].icon
            : searchTypeButtons[1].icon;

    const handleMobileMenuButtonClick = () => {
        setMenuHidden(!menuHidden);
    };

    const handleKeyDown = event => {
        if (
            event.key === " " ||
            event.key === "Enter" ||
            event.key === "Spacebar"
        ) {
            // "Spacebar" for IE11 support
            // Prevent the default action to stop scrolling when space is pressed
            event.preventDefault();
            setSearchType(event.currentTarget.dataset.id);
            setMenuHidden(!menuHidden);
        }
    };

    // dynamically change search bar placeholder text based on breakpoints & search toggle button type:
    const { browserWidth } = useViewport();
    const isPhotos = searchType !== "Icons";
    const defaultPlaceholder = placeholderText({ browserWidth, isPhotos });

    const handleSearchType = event => {
        // we get the data-id to set as the value since we're using an icon w/ no text for mobile:
        setSearchType(event.currentTarget.dataset.id);
        setMenuHidden(!menuHidden);
    };

    return (
        <>
            <Dropdown
                role="navigation"
                ref={mobileMenuRef}
                className="search-type-toggle-dropdown"
            >
                <ToggleButton
                    className="mobile-toggle-button"
                    aria-expanded="false"
                    aria-label="Search Type"
                    value={searchType}
                    onClick={handleMobileMenuButtonClick}
                >
                    {dropdownButtonValue}
                    <ButtonText>{searchType}</ButtonText>
                    <AngleDownSvg />
                </ToggleButton>
                <DropdownContents
                    id="mobile-dropdown-menu"
                    className={
                        menuHidden || outsideClick
                            ? "menu-hidden dropdown-menu"
                            : "dropdown-menu"
                    }
                >
                    {searchTypeButtons.map(button => {
                        return (
                            <DropdownOption
                                tabIndex="0"
                                onClick={handleSearchType}
                                onKeyDown={handleKeyDown}
                                key={button.value}
                                data-id={button.value}
                                aria-label={`Search Type ${button.value}`}
                                className={
                                    searchType === button.value && "selected"
                                }
                                role="button"
                            >
                                {button.icon}
                                <ButtonText>{button.value}</ButtonText>
                            </DropdownOption>
                        );
                    })}
                </DropdownContents>
            </Dropdown>

            <HeaderSearch
                selectedSearchType={searchType}
                placeholder={placeholder ? placeholder : defaultPlaceholder}
            />
        </>
    );
};

DefaultSearch.propTypes = {
    placeholder: PropTypes.string
};

export default DefaultSearch;
